import { render, staticRenderFns } from "./poverty.vue?vue&type=template&id=a4b751dc&scoped=true&"
import script from "./poverty.vue?vue&type=script&lang=js&"
export * from "./poverty.vue?vue&type=script&lang=js&"
import style0 from "./poverty.vue?vue&type=style&index=0&id=a4b751dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b751dc",
  null
  
)

component.options.__file = "poverty.vue"
export default component.exports